import firebase from 'firebase/app';
const isLocalHost = window.location.hostname === 'localhost';

export default class ClientsForOwnerModel {

  constructor({ ownerId }) {
    this.ownerId = ownerId;
  }

  get = async () => {
    const ownerId = this.ownerId;
    let clients = [];
    const db = firebase.firestore();
    try {
      clients = await db.collection('clients').where('ownerId','==', ownerId).get();
      clients = clients.docs.map(doc => ({ ...doc.data(), id: doc.id, clientId: doc.id }));
      if (clients.length !== 1) { console.log('[ERROR] Not exactly one for owner:', ownerId); }
    } catch {
      clients = [];
    }
    return clients;
  }

}
